"use client";

import useIsMobile from "@/hooks/useIsMobile";
import { motion } from "framer-motion";

export default function BounceBall({
  children,
  delay = 0,
  bounceHeight = 100,
  bounces = 3,
}) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <>{children}</>;
  }

  // Create keyframes for bounce effect
  const createBounceKeyframes = () => {
    const keyframes = [bounceHeight];
    let currentHeight = bounceHeight;

    for (let i = 0; i < bounces; i++) {
      currentHeight *= 0.5; // Each bounce is half the previous height
      keyframes.push(-currentHeight, 0);
    }

    return keyframes;
  };

  return (
    <motion.div
      initial={{
        opacity: 0,
        y: -bounceHeight,
      }}
      whileInView={{
        opacity: 1,
        y: createBounceKeyframes(),
      }}
      transition={{
        duration: 1.2,
        delay,
        opacity: { duration: 0.3 },
        y: {
          duration: 1.2,
          ease: "easeOut",
          times: [0, 0.2, 0.4, 0.6, 0.8, 0.9, 1],
        },
      }}
      viewport={{ once: true, margin: "-50px" }}
    >
      {children}
    </motion.div>
  );
}
